<template>
  <v-list-tile ripple two-line class="mb-2" :key="contentId">
    <v-list-tile-action class="pr-2">
      <nx-image :src="contentThumbnailUrl"></nx-image>
    </v-list-tile-action>

    <v-list-tile-content class="list-item__content">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-list-tile-title v-on="on">{{contentTitle | capitalize }}</v-list-tile-title>
          <v-list-tile-sub-title :color="subtitleColor">
            {{ subtitle }}
          </v-list-tile-sub-title>
        </template>
        <span>{{ contentTitle }}</span>
      </v-tooltip>
    </v-list-tile-content>

    <v-list-tile-action v-if="editable">
      <v-btn
        icon
        :to="{name: 'content.editor', params: { id: contentId, type: contentType }}"
        target="_blank">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import NxImage from '@/components/media/Image.vue';

export default {
  name: 'nx-unpublished-contents-modal-list-item',
  components: { NxImage },
  props: {
    contentId: {
      type: Number,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    contentTitle: {
      type: String,
      required: true,
    },
    contentThumbnailUrl: {
      type: String,
    },
    contentIsPublished: {
      type: Boolean,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    subtitleColor: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
